//Content.js
import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import { Button } from "@mui/material";
const axios = require('axios');
import { globalConfig } from "../../config/config";



export default class ViewVCSObjects extends Component {

	
	constructor(props)
	{
		console.log(props);
		super(props);
	}
	state = {
    vcsObjects: []
  	};

	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
      axios.get(`${globalConfig.apiDatahubUrl}/vcs-objects/`,globalConfig.hardcoded_header).then(res => {
      const vcsObjects = res.data;
      console.log(vcsObjects);
      this.setState({ vcsObjects });
      console.log(res.data[0]);
		});
		
	}

	render(){

        return (
			<>
		
				<div class="container-fluid">

      <div style={{ display: "flex", justifyContent: "space-between" }}>
			  <h4>Versions</h4>
			  <div>
			  <Link to="/waves">
			  	<Button variant="contained">Go Back</Button>
			  </Link>
			  </div>
      </div>
      <hr />

      <div className="form-group row">
      	<table class="table table-bordered table-striped">
      	<thead>
      	<tr>
      	<th scope="col">#</th>
      	<th scope="col">Name</th>
     	<th scope="col">Description</th>
     	<th scope="col">Version</th>
     	<th scope="col">Locked</th>
     	<th scope="col">Who Locked It</th>
     	<th scope="col">Locked At</th>
     	<th scope="col">Action</th>
    	</tr>
  		</thead>
  		<tbody>

          {this.state.vcsObjects.map( ( {vcsObjectId, vcsObjectName, vcsObjectDescription, revisionNumber, 
          							isLocked, lockUserid, lockTimestamp} ) => {
  					  return <tr><
  					  	td>{vcsObjectId}</td>
  					  	<td>{vcsObjectName} </td>
  					  	<td> {vcsObjectDescription}</td>
  					  	<td> {revisionNumber}</td>
  					  	<td> {isLocked}</td>
  					  	<td> {lockUserid}</td>
  					  	<td> {lockTimestamp}</td>
						<td>
							<button class="btn btn-success">Edit</button>&nbsp; 
  					  		<button class="btn btn-danger">Delete</button>
  					  	</td>
  					  	</tr>
					}) 
				}
        </tbody>
        </table>
      </div>
      </div>
	</>		
);
}
}
